export default function PHP_Constants() {
  return (
    <div>
      <h1>PHP_Constants</h1>
    </div>
  );
}
